<template>
<div class="content-header">
  <q-header>
    <q-toolbar>
      <q-toolbar-title>{{ ranName }}</q-toolbar-title>

      <q-tabs v-model="tab" >
        <q-tab name="home" label="Home" @click="$emit('tab-change', 'home')"/>
        <q-tab name="news" label="News" @click="$emit('tab-change', 'news')"/>
        <q-tab name="item-shop" label="Item Shop" @click="$emit('tab-change', 'item-shop')"/>
        <q-tab name="download" label="Download" @click="$emit('tab-change', 'download')"/>
        <q-tab name="server-info" label="Server Info" @click="$emit('tab-change', 'server-info')"/>
        <q-tab name="ranking" label="Ranking" @click="$emit('tab-change', 'ranking')"/>
      </q-tabs>
    </q-toolbar>
  </q-header>
</div>
</template>
<script>
export default {
  name: 'ContentHeader',
  data () {
    return {
      tab: 'home'
    }
  },
  computed: {
    ranName () {
      return process.env.VUE_APP_RAN_NAME
    }
  }
}
</script>

<style lang="scss">
.content-header {
  position: relative;
  .q-layout__section--marginal {
    background-color: $backgroundHeader;
  }
  .q-tab {
    margin-left: 20px;
    margin-right: 20px;
  }
}
</style>